module.exports = __webpack_public_path__ + "img/02-ball-1.69b53b23.svg";